
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/apache-kafka",
      function () {
        return require("private-next-pages/destinations/apache-kafka.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/apache-kafka"])
      });
    }
  